const DOCUMENT_URL_MARKER = 'document?url=';

// Bare storage path (`{tenant}/{patient}/{file}`) from a value that may be a full or partial
// `api/v1/document?url=…` link — timeline rows stored such links between 7.2.0 and this fix (SR-48540).
export function documentStoragePath(value: string): string {
  if (!value) {
    return value;
  }
  const at = value.lastIndexOf(DOCUMENT_URL_MARKER);
  if (at < 0) {
    return value;
  }
  return decodeURIComponent(value.substring(at + DOCUMENT_URL_MARKER.length).split('&')[0]);
}

export function documentFileName(value: string): string {
  return documentStoragePath(value).split('/').pop();
}
